import { render } from "./z-profile-skelet.vue?vue&type=template&id=10e7b961&scoped=true"
const script = {}

import "./z-profile-skelet.vue?vue&type=style&index=0&id=10e7b961&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e7b961"]])

export default __exports__